<template>
  <div class="examlist">
    <div class="header">
      主题类型：
      <el-select v-model="params.status" clearable>
        <el-option v-for="item in examstate" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-input v-model="params.searchValue" :placeholder="$t('Education.languages16')+$t('Education.languages10')+$t('Education.languages01')" style="width: 200px;margin:0 30px"></el-input>
      <el-button type="primary" @click="search">{{ $t('Education.languages01') }}</el-button>
      <el-button type="primary" @click="ClickExport">{{ $t('Education.languages20') }}</el-button>
    </div>

    <div class="content">
      <el-table v-loading="loadings" :data="Examstatistics" :cell-style="{'text-align':'center'}" style="width: 100%;text-align: center">
        <el-table-column prop="trainName" label="培训主题"></el-table-column>
        <el-table-column prop="examTitle" label="考试标题"></el-table-column>
        <el-table-column prop="examTime" label="考试时间"></el-table-column>
        <el-table-column prop="userId" label="考生学号"></el-table-column>
        <el-table-column prop="realName" label="考生姓名"></el-table-column>
        <el-table-column label="考试状态">
          <template v-slot="scope">
            <span v-if="scope.row.examStatus==0">未参加</span>
            <span v-if="scope.row.examStatus==1">正在考试</span>
            <span v-if="scope.row.examStatus==2">考试结束</span>
          </template>
        </el-table-column>
        <el-table-column label="分数">
          <template v-slot="scope">
            <span v-if="scope.row.examScore==0 || scope.row.examScore==null">--</span>
            <span v-else class="operateitem" @click="$router.push('scoredetail?examRecordId='+scope.row.examRecordId)">{{scope.row.examScore}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Education.languages42')">
          <template v-slot="scope">
            <span v-if="scope.row.examStatus!=2">--</span>
            <span v-else class="operateitem" @click="$router.push('papergrad?examRecordId='+scope.row.examRecordId)">{{ scope.row.examScore?$t('Education.languages75'):$t('Education.languages74') }}</span>
          </template>
        </el-table-column>占比
      </el-table>
      <el-pagination  style="margin-top: 20px;"  hide-on-single-page  @current-change="handleCurrentChange"  :current-page.sync="params.pageNum"  :page-size="params.pageSize"  layout="total, prev, pager, next"  :total="params.Total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default ({
  name:'examlist',
  data(){
    return{
      loadings:true,
      params:{
        pageNum: 1,
        pageSize: 10,
        searchValue: "",
        status:'',
        trainId: '2'
      },
      Examstatistics:[],
      examstate:[
        {label:'未参加',value:'0'},
        {label:'正在考试',value:'1'},
        {label:'考试结束',value:'2'}
      ],
    }
  },
  created() {
    this.getExamStatistics();
  },
  methods:{
    getExamStatistics(){
      this.loadings=true;
      this.$Http_Post('edu/train/getExamStatistics',this.params).then(res=>{
        if(res.Code==0){
          this.Examstatistics=res.Data;
          this.params.Total=res.Counts;
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.loadings=false;
      });
    },
    search(){
      this.params.pageNum=1;
      this.getExamStatistics();
    },
    handleCurrentChange(val){
      this.params.pageNum=val;
      this.getExamStatistics();
    },
    ClickExport(){
      location.href=process.env.VUE_APP_URL+'edu/train/exportExamStatistics?searchValue='+this.params.searchValue+'&status='+this.params.status+'&trainId='+this.params.trainId
    }
  }
})
</script>
<style scoped>
.header{display: flex;align-items:center;background: #fff;padding:30px;}
.content{background:#fff;padding:30px;margin-top:20px;}
.operateitem{padding: 0 5px 0 0;color:#0088ff;cursor: pointer}
</style>